import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useSearchParams } from 'src/utils/useSearchParams'
import ContentLayout from 'src/components/ContentLayout';
import SBPLogo from 'src/components/SBPLogo';
import PageSpin from 'src/components/PageSpin';
import Text from 'src/components/Text';
import Link from 'src/components/Link';
import HelpLink from 'src/components/HelpLink';
import { postInvitationFromOrganizationAPI } from 'src/serverApi/invitations';
import routes from 'src/constants/routes';
import Form from './Form';
import styles from './styles.module.scss';

const Authorization: React.FC = () => {
  const [searchParams] = useSearchParams();
  const confirmationId = searchParams.get('confirmation');
  const returnUrl = searchParams.get('returnUrl');
  
  const [isLoading, setIsLoading] = useState(false);
  const [invitationData, setInvitationData] = useState<any>();
  
  const loadInvitationData = async (confirmationId: any) => {
    try {
      setIsLoading(true);
      const data = await postInvitationFromOrganizationAPI(confirmationId);
      setInvitationData(data);
    } catch (error: any) {
      if (error.type === 'NOT_FOUND') {
        toast.error('Ссылка недействительна. Получите новую ссылку и перейдите по ней.');
        return;
      }
      toast.error('При загрузке данных приглашения произошла ошибка');
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    if (confirmationId){
      loadInvitationData(confirmationId);
    }
  }, [confirmationId]);
  
  if (isLoading) {
    return <PageSpin />;
  }
  
  return (
    <ContentLayout size="small">
      <HelpLink className={styles['help']}/>
      <SBPLogo className={styles['sbp-logo']} />
      <Text type="h2" className={styles['title']}>Вход</Text>
      <Form
        returnUrl={returnUrl}
        inviteConfirmationId={confirmationId}
        inviteOrganizationUeid={invitationData?.organizationUeid}
      />
      <Link to={routes.passwordRecovery} className={styles['recovery-link']}>Забыли пароль?</Link>
    </ContentLayout>
  );
};

export default Authorization;
